import React from 'react';
import { connect } from 'react-redux';
import { Dialog, Loading } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';

function DiffDialog({ visible, handleClose, loading, result }) {
  return (
    <Dialog visible={visible} onClose={handleClose} header='检查结果' footer={null}>
      <Loading loading={loading}>
        <Descriptions column={1}>
          <Descriptions.Item label='指标描述' value={result.metricsDescription} />
          <Descriptions.Item label='执行结果' value={result.result} />
          <Descriptions.Item label='阈值' value={result.threshold} />
        </Descriptions>
      </Loading>
    </Dialog>
  );
}

export default connect((state) => ({
  loading: state.cluster.fetchingUnHealth,
  result: state.cluster.unhealthResult,
}))(DiffDialog);
